/* global store */
export const selectActiveArtboard = (activeArtboard) => {
  store.dispatch({ type: 'SET_ACTIVE_ARTBOARD', activeArtboard });
};

export const setRootDocument = (rootDocument) => {
  store.dispatch({ type: 'SET_ROOT_DOCUMENT', rootDocument });
};

export const setRootElement = (rootElement) => {
  store.dispatch({ type: 'SET_ROOT_ELEMENT', rootElement });
  store.dispatch({ type: 'SET_API_ROOT_ELEMENT', rootElement });
};

export const setRootBodyElement = (rootBodyElement) => {
  store.dispatch({ type: 'SET_ROOT_BODY_ELEMENT', rootBodyElement });
};

export const artboardRendered = () => {
  store.dispatch({ type: 'ARTBOARD_RENDERED' });
};

export const setTimeline = (timeline) => {
  store.dispatch({ type: 'SET_TIMELINE', timeline });
  store.dispatch({ type: 'SET_API_TIMELINE', timeline });
};

export const setApiTimeline = (timeline) => {
  store.dispatch({ type: 'SET_API_TIMELINE', timeline });
};

export const resetTimeLine = () => {
  store.dispatch({ type: 'RESET_TIMELINE' });
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/actions/artboardActions.js